export const GA4_EVENT = {
   ADD_SHIPMENT_TEMPLATE: "add_shipment_template",
   PRODUCTS_CHANGE_APPROVAL_STATUS: "products_change_approval_status",
   PRODUCTS_DETAILS_UPDATE: "products_details_update",
   PRODUCTS_DELETED: "products_deleted",
   PRODUCT_LIST_FILTER: "product_list_filter",
   VIEW_PRODUCT_DEALS: "view_product_deals",
   PRODUCT_FILTERED_SEARCH: "product_filtered_search",
   SEARCH_PRODUCT: "search_product",
   OPEN_PRODUCT_FOR_SALE: "open_product_for_sale",
   PRODUCT_LINK_CLICK: "product_link_click",
   DELETE_PRODUCT: "delete_product",
   DELETE_PRODUCT_SUCCESS: "delete_product_success",
   DELETE_PRODUCT_DISMISS: "delete_product_dismiss",
   BUTTON_CLICK: "button_click",
   PUT_UP_FOR_SALE_SUCCESS: "put_up_for_sale_success",
   PUT_UP_FOR_SALE_DISMISS: "put_up_for_sale_dismiss",
   PUT_ON_HOLD_SUCCESS: "put_on_hold_success",
   PUT_ON_HOLD_DISMISS: "put_on_hold_dismiss",
   ADD_VARIANT_SUCCESS: "add_variant_success",
   ADD_VARIANT_DISMISS: "add_variant_dismiss",
   ADD_ADDITIONAL_VARIANT_SUCCESS: "add_additional_variant_success",
   ADD_ADDITIONAL_VARIANT_DISMISS: "add_additional_variant_dismiss",
   REQUEST_UPDATE_REPORT_BUG_SUCCESS: "request_update_report_bug_success",
   REQUEST_UPDATE_REPORT_BUG_DISMISS: "request_update_report_bug_dismiss",
   APPLY_SELECTED_ONES: "apply_selected_ones",
   SAVE_CHANGES: "save_changes",
   WATCH_TUTORIAL: "watch_tutorial",
   WATCH_TUTORIAL_DISMISS: "watch_tutorial_dismiss",
   MENU_CLICK: "menu_click",
   USE_ALL_BALANCE: "use_all_balance",
   EARLY_SETTLEMENT_CALCULATE:"calculate_success",
   EARLY_SETTLEMENT_CALCULATE_FAIL:"calculate_fail",
   CHECKBOX_CHECKED: "checkbox_checked",
   CHECKBOX_UNCHECKED: "checkbox_unchecked",
   EARLY_SETTLEMENT_CALCULATE_DISMISS:"calculate_dismiss",
   REQUEST_EARLY_PAYMENT:"request_early_payment",
   REQUEST_EARLY_PAYMENT_SUCCESS:"request_early_payment_success",
   REQUEST_EARLY_PAYMENT_DISMISS:"request_early_payment_dismiss",
   REQUEST_EARLY_PAYMENT_FAIL: "request_early_payment_fail",
   GO_TO_PRODUCT_DETAIL_CLICK: "go_to_product_detail_click",
}
